import script from "./ProcessSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessSection.vue?vue&type=script&setup=true&lang=js"

import "./ProcessSection.vue?vue&type=style&index=0&id=3cc24ae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc24ae6"]])

export default __exports__